import { render, staticRenderFns } from "./ExibicaoRegulamento.vue?vue&type=template&id=6de82516&scoped=true&"
import script from "./ExibicaoRegulamento.vue?vue&type=script&lang=js&"
export * from "./ExibicaoRegulamento.vue?vue&type=script&lang=js&"
import style0 from "./ExibicaoRegulamento.vue?vue&type=style&index=0&id=6de82516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de82516",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
